import PptxGenJS from "pptxgenjs"
import { slideFrom } from '../util/slideFrom'
import { KojinPptxComponentsProps } from '../types'

const headerLayout = {
  height: 0.8,
  photoImage: {
    margin: 0.1,
  },
  nameWidth: 6,
  nenrei: {
    captionWidth: 0.8,
    width: 1,
    margin: 0.15
  }
}

type photoImageProps = KojinPptxComponentsProps & {
  top: number
}
const photoImage = ({
  slide, 
  kojin,
  avatarImage,
  top
}: photoImageProps) => {
  if (!kojin) return

  const avatarPath = avatarImage ? undefined : `${process.env.PUBLIC_URL}/avatar/${
    (!kojin.kojinCode) ? 'kojinNoImage_nomatch.png' :
    (kojin.seibetuCode === '1') ? 'kojinNoImage_Male.png' :
    (kojin.seibetuCode === '2') ? 'kojinNoImage_Female.png' : 'kojinNoImage_unknwon.png'
  }`
  const imageSize = headerLayout.height - (headerLayout.photoImage.margin + headerLayout.photoImage.margin)
  slide.addImage({
    altText: kojin.isiName ?? 'image',
    data: avatarImage,
    path: avatarPath,
    x: headerLayout.photoImage.margin,
    y: top + headerLayout.photoImage.margin,
    sizing: { type: 'contain', w: imageSize, h: imageSize }
  })
}

type nameProps = KojinPptxComponentsProps & {
  top: number
}
const name = ({
  slide,
  layout,
  kojin,
  top
}: nameProps) => {
  if (!kojin || !kojin.isiName) return

  slide.addText([{
    text: (kojin.isiNameKana ?? '--'),
    options: {
      ...layout.textOption,
      fontSize: layout.baseFont.fontSize * 1.2,
      breakLine: true
    }
  }, {
    text: kojin.isiName,
    options: {
      ...layout.textOption,
      fontSize: layout.baseFont.fontSize * 2.3,
      bold: true,
      breakLine: false
    }
  }, {
    text: '　先生',
    options: {
      ...layout.textOption,
      fontSize: layout.baseFont.fontSize * 1.5,
      breakLine: true
    }
  }], {
    x: 0, y: top, w: headerLayout.nameWidth, h: headerLayout.height,
    margin: [60, 20, 5, 5], 
    align: 'left', valign: 'bottom',
    breakLine: true, wrap: false, autoFit: true
  })
}

type actorProps = KojinPptxComponentsProps & {
  top: number
}
const actor = ({
  slide,
  layout,
  kojin,
  top
}: actorProps) => {
  if (!kojin) return

  const actorTexts = []
  if (kojin.actor?.isComActor) actorTexts.push("CareNet.com出演")
  if (kojin.actor?.isDvdActor) actorTexts.push("DVD出演")
  if (kojin.actor?.isTvActor) actorTexts.push("CareNeTV出演")
  if (kojin.picksExpert) actorTexts.push("Doctors'Picks Expert Picker")
  if (actorTexts.length === 0) return

  slide.addText([{
    text: actorTexts.join('／'),
    options: {...layout.textOption, fontSize: layout.baseFont.fontSize * 1.3, color: 'ad0026', bold: true }
  }], {
    x: headerLayout.nameWidth, y: top,
    w: slideFrom(layout, 'width', headerLayout.nameWidth + headerLayout.nenrei.captionWidth + headerLayout.nenrei.width),
    h: headerLayout.height,
    margin: [10, 10, 0, 0],
    align: 'left', valign: 'middle'
  })
}

type nenreiProps = KojinPptxComponentsProps & {
  top: number
}
const nenrei = ({
  slide,
  layout,
  kojin,
  top
}: nenreiProps) => {
  if (!kojin || kojin.nenrei === null || kojin.nenrei === undefined) return

  slide.addText([{
    text: '年齢',
    options: {
      ...layout.textOption,
      fontSize: layout.baseFont.fontSize * 1.7,
      color: 'ffffff'
    }
  }], {
    x: slideFrom(layout, 'right', headerLayout.nenrei.captionWidth + headerLayout.nenrei.width),
    y: top + headerLayout.nenrei.margin,
    w: headerLayout.nenrei.captionWidth,
    h: headerLayout.height - (headerLayout.nenrei.margin + headerLayout.nenrei.margin),
    margin: [0, 0, 5, 5], 
    align: 'center', valign: 'bottom',
    fill: { color: '4c4948' }
  })
  slide.addText([{
    text: `${kojin.nenrei}歳`,
    options: {
      ...layout.textOption,
      fontSize: layout.baseFont.fontSize * 1.7
    }
  }], {
    x: slideFrom(layout, 'right', headerLayout.nenrei.width),
    y: top + headerLayout.nenrei.margin,
    w: headerLayout.nenrei.width,
    h: headerLayout.height - (headerLayout.nenrei.margin + headerLayout.nenrei.margin),
    margin: [0, 0, 5, 5], 
    align: 'center', valign: 'bottom',
    fill: { color: 'd9d9d9' }
  })
}

type headerProps = KojinPptxComponentsProps & {
  top: number
}
type headerReturnValue = {
	slide: PptxGenJS.Slide
  bottom: number
}
export const header = ({
  top,
  ...other
}: headerProps): headerReturnValue => {
  const { pptx, layout, slide } = other

  photoImage({ ...other, top })
  name({ ...other, top })
  actor({ ...other, top })
  nenrei({ ...other, top })

  const headerWidth = slideFrom(layout, 'width', 0, false)
  slide.addShape(pptx.ShapeType.line, {
    x: 0, y: top + headerLayout.height,
    w: headerWidth, h: 0,
    line: { color: "ad0026", width: 3 }
  })
  return {
    slide,
    bottom: top + headerLayout.height
  }
}
